import { jsonToQueryString } from "../utils/Common"
import { privateFetch, publicFetch } from "../libs/axios"
import {
  GetAllEventsRequestType,
  GetAllEventsResponseType,
  GetBookingCalendarEventsByCrewResponseType,
  GetBookingCalendarEventsByProductResponseType,
  GetBookingCalendarEventsRequestType,
  GetBookingCalendarEventsResponseType,
  GetBookingsFromSlotIdResponseType,
  GetDayLevelAvailabilityResponseType,
  UpdateSlotStatusRequestType,
  UpdateSlotStatusResponseType,
} from "../types/CalendarTypes"

export const getDayLevelAvailability = async ({
  from_date,
  to_date,
  products,
  categories,
  search_text,
  slot_status,
  active_products,
}: GetAllEventsRequestType) => {
  const params = new URLSearchParams({
    from_date,
    to_date,
    products: products?.length ? products.join(",") : "",
    categories: categories?.length ? categories.join(",") : "",
    search_text: search_text ?? "",
    slot_status: slot_status ?? "",
    active_products: active_products ?? "true",
  })
  return await privateFetch().get<GetDayLevelAvailabilityResponseType[]>(
    `/api/v1/products-availability/day-level/range?${params.toString()}`
  )
}

export const getAllEvents = async (
  {
    from_date,
    to_date,
    products,
    categories,
    search_text,
    slot_status,
    active_products,
  }: GetAllEventsRequestType,
  isIntegratedPage?: boolean
) => {
  const params = new URLSearchParams({
    from_date,
    to_date,
    products: products?.length ? products.join(",") : "",
    categories: categories?.length ? categories.join(",") : "",
    search_text: search_text ?? "",
    slot_status: slot_status ?? "",
    active_products: active_products ?? "true",
  })
  if (isIntegratedPage) {
    return await publicFetch().get<GetAllEventsResponseType[]>(
      `/api/v1/public/products-availability/range?${params.toString()}`
    )
  }
  return await privateFetch().get<GetAllEventsResponseType[]>(
    `/api/v1/products-availability/range?${params.toString()}`
  )
}

export const updateSlotStatus = async (product_id: string, body: UpdateSlotStatusRequestType) =>
  await privateFetch().post<string[] | UpdateSlotStatusResponseType>(
    `/api/v1/product/${product_id}/availability/update-slot`,
    body
  )

export const getBookingCalendarEventsByCrew = async ({
  from_date,
  to_date,
}: GetBookingCalendarEventsRequestType) =>
  await privateFetch().get<GetBookingCalendarEventsByCrewResponseType[]>(
    `/api/v1/booking/calendar?start_date=${from_date}&end_date=${to_date}&group_by=crew`
  )

export const getBookingCalendarEvents = async ({
  from_date,
  to_date,
  products,
  search_text,
  status,
}: GetBookingCalendarEventsRequestType) => {
  const params = new URLSearchParams({
    from_date,
    to_date,
    products: products?.length ? products.join(",") : "",
    search_text: search_text ?? "",
    status: status ?? "",
  })

  return await privateFetch().get<GetBookingCalendarEventsResponseType[]>(
    `/api/v1/booking/availability/?${params.toString()}`
  )
}

export const getBookingCalendarEventsByProduct = async ({
  from_date,
  to_date,
}: GetBookingCalendarEventsRequestType) =>
  await privateFetch().get<GetBookingCalendarEventsByProductResponseType[]>(
    `/api/v1/booking/calendar?start_date=${from_date}&end_date=${to_date}&group_by=product`
  )

export const getBookingsFromSlotId = async (slot_id: string, filter = {}) =>
  await privateFetch().get<GetBookingsFromSlotIdResponseType[]>(
    `/api/v1/product-availability/${slot_id}/bookings${jsonToQueryString(filter)}`
  )
